import config from '../config';
import {
  customFetch,
  authHeader,
  jsonHeader,
  handleResponse,
  commonRequestOptions,
  subjects,
} from '../helpers';

const endpointPath = config.api.API_URL + '/principal';

export const principalService = {
  getById,
};

function getById(principalIds, signal) {
  const requestOptions = {
    method: 'POST',
    headers: {
      ...authHeader(),
      ...jsonHeader(),
    },
    ...commonRequestOptions(),
    body: JSON.stringify({ principalIds }),
  };

  return customFetch(`${endpointPath}/get_by_id`, requestOptions, signal).then(handleResponse);
}
